import React, { useState } from "react";
import { useRoutes, NavLink } from "react-router-dom";
import SecurityHeaderImage from "../../assets/images/login/security-policy.png";
const BannerSection = () => {
  return (
    <>
      <section className="topPageBanner _border-bottom">
        <div className="max-container">
          <div className="padd-90">
            <div className="grid-auto-fit align-items-center max-width950">
              <div>
                <h1 className="heading39px roboto-regular mb20 text-color-131415">
                  <span className="roboto-bold">SECURITY</span> POLICY
                </h1>

                <p className="roboto-regular heading16px mb30 text-color-131415">
                  "Our security policy is like a superhero - it protects your
                  data and fights off cyber villains, so you don't have to!"
                </p>
                <NavLink
                  to={"/contact-us"}
                  className="common-btn-class main-btn-primary roboto-regular"
                >
                  Contact us
                </NavLink>
              </div>
              <div className="text-center">
                <img
                  src={SecurityHeaderImage}
                  className="img-responsive position-relative"
                  alt="Double Your Qualified Leads"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default BannerSection;
